import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivationEnd, Router } from '@angular/router';
import { MsalBroadcastService } from '@azure/msal-angular';
import { BrowserUtils, InteractionStatus } from '@azure/msal-browser';
import { filterUndefined } from 'src/app/lego-utils';
import { Subscription } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { AccountService, AnalyticsService } from 'src/app/services';
import { UsersnapService } from 'src/app/services/usersnap.service';
import { SessionService } from 'src/app/state';
import { IUser } from './models';

@Component({
  selector: 'em-app-root',
  styleUrls: ['./app.component.less'],
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  public readonly isIframe = BrowserUtils.isInIframe() && !window.opener;
  public readonly accountActive$ = this.accountService.accountActive$;
  private readonly subscriptions = new Subscription();
  public constructor(
    private readonly router: Router,
    private readonly sessionService: SessionService,
    private readonly analyticsService: AnalyticsService,
    private readonly broadcastService: MsalBroadcastService,
    private readonly accountService: AccountService,
    private readonly usersnapService: UsersnapService
  ) {}

  public ngOnInit(): void {
    // App-owned token requests must not race redirect handling or MsalGuard's login.
    this.subscriptions.add(
      this.broadcastService.inProgress$
        .pipe(
          filter((status) => status === InteractionStatus.None),
          map(() => this.accountService.setActiveAccount()),
          filterUndefined(),
          take(1),
          switchMap(() => this.sessionService.loadADUser())
        )
        .subscribe()
    );

    this.subscriptions.add(
      this.sessionService.user$
        .pipe(filterUndefined())
        .subscribe(({ department, jobTitle }: IUser) => {
          this.analyticsService.user = { department, jobTitle };
        })
    );

    this.subscriptions.add(
      this.sessionService.role$.pipe(filterUndefined()).subscribe((role) => {
        this.analyticsService.role = role;
      })
    );

    this.subscriptions.add(
      this.router.events
        .pipe(filter((x): x is ActivationEnd => x instanceof ActivationEnd))
        .subscribe(({ snapshot: { routeConfig, queryParams } }) => {
          const tab = queryParams.tab as string;
          const initialSubTab = queryParams.tab === 'teamcenter' ? 'Element Design' : false;
          const page = routeConfig?.path ?? 'welcome';

          this.analyticsService.location = {
            page,
            ...(tab && { tab }),
            ...(initialSubTab && { subTab: initialSubTab }),
          };
        })
    );

    void this.usersnapService.initialize();
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
